import InfoProduct from "../components/info-product/InfoProduct";
export default function InfoProductPage() {
  return (
    <div>
      <InfoProduct></InfoProduct>
    </div>
  );
}
